














































































































































































































































import LayoutFullWidth from "@/components/layouts/LayoutFullWidth.vue";
import AppNotificationBar from "@/components/AppNotificationBar.vue";
import DonutChart from "@/components/DonutChart.vue";
import OverviewFlushCache from "@/components/OverviewFlushCache.vue";
import HeadingButtons from "@/components/HeadingButtons.vue";
import { NotificationType } from "@/types/notification";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    LayoutFullWidth,
    AppNotificationBar,
    DonutChart,
    OverviewFlushCache,
    HeadingButtons,
  },
})
export default class StyleGuideView extends Vue {
  buttonClasses = ["default", "button-primary", "button-secondary", "button-warning", "button-alert"];

  get notificationTypes() {
    return NotificationType;
  }

  get sampleChartValues() {
    return [
      { label: "memory used", value: 33 },
      { label: "memory available", value: 67 },
    ];
  }
}
